import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import { UpdatePipelineStageInput } from '@/gql/graphql';
import { createDraftPipelineMutation } from './createDraftPipelineMutation';
import draftMutationKeys from './keyFactory';
import { applyOptimisticUpdateStage } from './optimisticUpdates';

const UPDATE_PIPELINE_STAGE_MUTATION = graphql(`
  mutation DraftUpdatePipelineStage($input: UpdatePipelineStageInput!) {
    updatePipelineStage(input: $input) {
      id
      title
      colour
      guard {
        ... on PipelineGuardOr {
          __typename
          children {
            ... on PipelineGuardAnd {
              __typename
              children {
                ... on PipelineGuardSimpleCondition {
                  __typename
                  type
                }
                ... on PipelineGuardProjectHasTagCondition {
                  __typename
                  tag {
                    publicId
                    name
                    colour
                  }
                }
                ... on PipelineGuardCustomFieldCondition {
                  ...CustomFieldGuardCondition
                }
                ... on PipelineGuardNot {
                  __typename
                  child {
                    ... on PipelineGuardSimpleCondition {
                      __typename
                      type
                    }
                    ... on PipelineGuardProjectHasTagCondition {
                      __typename
                      tag {
                        publicId
                        name
                        colour
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`);

const useDraftUpdatePipelineStage = createDraftPipelineMutation()({
  mutationKey: draftMutationKeys.updatePipelineStage,
  mutationFn: (input: UpdatePipelineStageInput) => {
    return gqlClient.request(UPDATE_PIPELINE_STAGE_MUTATION, { input });
  },
  applyOptimisticUpdate: (data, variables) =>
    applyOptimisticUpdateStage(data, variables),
  squash: {
    entityId: (v) => v.id,
    merge: (older, newer) => ({ ...older, ...newer }),
  },
});

export default useDraftUpdatePipelineStage;
